import styled from "@emotion/styled";
import { useState, useEffect } from "react";

export interface LocalIframeProps {
    title?: string;
    content?: string;
    width?: number | string;
    height?: number | string;
}

const StyledIframe = styled("iframe")(({ theme }) => ({
    border: 0,
    borderRadius: theme.kaltura.shape.roundness2,
}));

/**
 * mount a given content inside an iframe. no kms action involved.
 */
export const LocalIframe = ({ width = 432, height = 243, title, content = "" }: LocalIframeProps) => {
    const [contentRef, setContentRef] = useState<HTMLIFrameElement | null>(null);
    const doc = contentRef?.contentWindow?.document;

    useEffect(() => {
        if (doc) {
            doc.write(content);

            const style_element = doc.createElement("style");
            style_element.textContent = "body { margin: 0; }";
            doc.head.appendChild(style_element);
        }
    }, [contentRef, doc, content]);

    return <StyledIframe width={width} height={height} title={title} ref={setContentRef}></StyledIframe>;
};

export default LocalIframe;
